export function cardTypeDetector(cardNumber) {
  const patterns = {
    visa: /^4/,
    mastercard: /^5[1-5]/,
    amex: /^3[47]/,
  };
  if (!cardNumber || typeof cardNumber !== 'string') return "";
  cardNumber = cardNumber.replace(/\D/g, "");
  for (const [type, pattern] of Object.entries(patterns)) {
    if (pattern.test(cardNumber)) return type.toUpperCase();
  }
  return "";
}

export function getLogoSrc(cardType, baseurl) {
  const file =
    cardType === "AMEX"
      ? "Amex.svg"
      : cardType === "MASTERCARD"
      ? "Mastercard.svg"
      : "Visa.svg";
  return `${baseurl}/assets/${file}`;
}

// Setup card type detection and logo display
export function setupCardTypeDetection(cardContainer, supportedCards, hosted_baseurl, onFieldEvent) {
  const iframe = cardContainer.querySelector("iframe");
  const logoContainer = cardContainer.querySelector(".logo-container");

  function renderInitialLogos() {
    logoContainer.innerHTML = "";
    supportedCards.forEach((cardType) => {
      const img = document.createElement("img");
      img.src = getLogoSrc(cardType, hosted_baseurl);
      img.alt = cardType;
      img.style.width = "25px";
      img.style.margin = "0 5px";
      logoContainer.appendChild(img);
    });
  }

  renderInitialLogos();

  window.addEventListener("message", (event) => {
    if (event.data.field === "card") {
      const cardNumber = (event.data.value || "").replace(/\s/g, "");
      const cardType = cardTypeDetector(cardNumber);
      logoContainer.innerHTML = "";

      if (cardType && supportedCards.includes(cardType)) {
        const img = document.createElement("img");
        img.src = getLogoSrc(cardType, hosted_baseurl);
        img.alt = cardType;
        img.style.width = "25px";
        img.style.margin = "0 5px";
        logoContainer.appendChild(img);
      } else {
        renderInitialLogos();
      }

      if (onFieldEvent) {
        onFieldEvent({ field: "card", value: cardNumber, cardType });
      }
    }
  });
}